<script setup lang="ts">
import type { QuizData } from '@vue-quiz-app/types/quiz';
import { inject } from 'vue';

const props = defineProps<{
  totalScore: number;
  totalQuestions: number;
  isWeighted: boolean;
}>();

const quizData = inject<QuizData>('quizData');

const possibleMaximum = quizData?.weighted
  ? Object.entries(quizData.questions).reduce((acc, curr) => (acc += Math.max(...Object.values(curr[1].points))), 0) // Add maximum points from every question
  : props.totalQuestions;

// Calculate % for non-weighted quiz
const userResult = props.isWeighted ? props.totalScore : Math.round((props.totalScore * 100) / possibleMaximum);

const resultString = props.isWeighted ? `${userResult}/${possibleMaximum}` : `${userResult}%`;

const quizTitle = document.querySelector('.header-banner__bot > h1')?.textContent || 'the quiz';

const currentURL = window.location.href;
</script>

<template>
  <div
    v-if="quizData"
    class="quiz-results quiz-done"
  >
    <h4>Great Job!</h4>
    <h2>
      You scored <span>{{ resultString }}</span
      >!
    </h2>
    <p>Thank you for taking {{ quizTitle }}. We hope you enjoyed testing your knowledge.</p>
    <hr />
    <h4>Share your score</h4>

    <div class="quiz-share">
      <a
        :href="`https://www.facebook.com/sharer/sharer.php?u=${currentURL}/?percentage=${userResult}`"
        class="link facebook"
        target="_blank"
        ><span>Facebook</span></a
      >
      <a
        :href="`https://twitter.com/home?status=${currentURL}/?percentage=${userResult}`"
        class="link twitter"
        target="_blank"
        ><span>Twitter</span></a
      >
      <a
        :href="`mailto:?&amp;body=${currentURL}/?percentage=${userResult}`"
        class="link mail"
        ><span>Mail</span></a
      >
    </div>

    <article
      v-if="quizData.finalText || quizData.promo"
      class="card_block"
    >
      <div
        v-if="quizData.finalText"
        v-html="quizData.finalText"
      ></div>

      <template v-else-if="quizData.promo">
        <h4 v-html="quizData.promo.subheading"></h4>
        <div class="contain">
          <h3 v-html="quizData.promo.title"></h3>
          <h2 v-html="quizData.promo.code"></h2>
          <p
            class="subtext"
            v-html="quizData.promo.description"
          ></p>
        </div>
        <div class="cta-wrapper">
          <p>
            <a
              class="btn red"
              :href="quizData.promo.buyTicketsLink"
              >BUY TICKETS</a
            >
          </p>
        </div>
      </template>
    </article>
  </div>
</template>

<style></style>
